import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { AxiosCustomDelete, AxiosCustomGet } from "../../../components/axios/AxiosCustom";
import Config from "../../../components/axios/Config";
import SwalToast from "../../../components/helpers/SwalToast";
import Title from "../../../components/common/Title/Title";
import Breadcrumb from "../../../components/common/Breadcrumb/Breadcrumb";
import "antd/dist/antd.css";
import CustomTable from "../../../components/common/Table/CustomTable";
import {
    AuthorizationList,
    CanAccess,
} from "../../../components/template/authorization/Authorization";
import { initFilterInput, renderColumns } from "./constans";
import Select from "react-select";
import { TiUser } from "react-icons/ti";
import TextInput from "../../../components/common/TextInput/TextInput";
import { Modal, Button, Input } from "antd";
import { convertDataExclusive } from "../helpers/convertDataExclusive";
import { convertEmployee } from "../helpers/convertEmployee";
import moment from "moment";
import AppRoutePath from "../../../router/AppRoutePath";
import { useHistory } from "react-router-dom";

const ExclusiveList = () => {
    const history = useHistory();
    const [records, setRecords] = useState();
    const [totalRecord, setTotalRecord] = useState(0);
    const [loading, setLoading] = useState(false);
    const [tablePagination, setTablePagination] = useState({});
    const [filterInput, setFilterInput] = useState(initFilterInput);
    const [modalDetail, setModalDetail] = useState(false);
    const [modalCancel, setModalCancel] = useState(false);
    const [listEmployee, setListEmployee] = useState([]);
    const [selected, setSelected] = useState({});
    const [customer, setCustomer] = useState({});
    const [reasonCancel, setReasonCancel] = useState('');

    useEffect(() => {
        getData();
    }, [filterInput]);

    useEffect(() => {
        getDataMaster()
    }, []);

    const handleTableChange = (pagination) => {
        setFilterInput((prev) => ({
            ...prev,
            page: pagination.current,
            pageSize: parseInt(pagination.pageSize),
        }));
    };

    const handleDetail = (record) => {
        console.log(record)
        getCustomerByNik(record.nik)
        setSelected(record)
        setModalDetail(true)
    };

    const getData = () => {
        setLoading(true);
        let params = {
            search: filterInput.search,
            status: filterInput.status,
            page: filterInput.page,
            page_size: filterInput.pageSize,
            assigned_employee_id: filterInput.assigned_employee_id
        };
        let url = `${process.env.REACT_APP_BASE_API_URL}gadai/exclusive`;
        AxiosCustomGet(url, Config({ Authorization: `Bearer ${Cookies.get("access_token")}` }, params),
            (response) => {
                setLoading(false);

                setRecords(convertDataExclusive(response.data.data.items));
                setTablePagination({
                    current: response.data.data.page,
                    pageSize: response.data.data.per_page,
                    total: response.data.data.total_item,
                });
                setTotalRecord(response.data.data.total_item)
            },
            (error) => {
                setLoading(false);
                if (error.response) {
                    SwalToast.fire({
                        icon: "error",
                        title: error.response.data,
                    });
                } else {
                    SwalToast.fire({
                        icon: "error",
                        title: "Whoops, something went wrong",
                    });
                }
            }
        );
    };

    const getDataMaster = () => {
        setLoading(true);
        let url = `${process.env.REACT_APP_BASE_API_URL}gadai/exclusive/master-data`;
        AxiosCustomGet(url, Config({ Authorization: `Bearer ${Cookies.get("access_token")}` }),
            (response) => {
                setListEmployee(convertEmployee(response.data.data.employees))
            },
            (error) => {
                setLoading(false);
                if (error.response) {
                    SwalToast.fire({
                        icon: "error",
                        title: error.response.data,
                    });
                } else {
                    SwalToast.fire({
                        icon: "error",
                        title: "Whoops, something went wrong",
                    });
                }
            }
        );
    };

    const getCustomerByNik = (nik) => {
        setLoading(true);
        let url = `${process.env.REACT_APP_BASE_API_URL}gadai/exclusive/customer-ktp/${nik}`;
        AxiosCustomGet(url, Config({ Authorization: `Bearer ${Cookies.get("access_token")}` }),
            (response) => {
                setLoading(false);
                setCustomer(response.data.data)
                console.log(response.data.data)
            },
            (error) => {
                setLoading(false);
                if (error.response) {
                    SwalToast.fire({
                        icon: "error",
                        title: error.response.data,
                    });
                } else {
                    SwalToast.fire({
                        icon: "error",
                        title: "Whoops, something went wrong",
                    });
                }
            }
        );
    };

    const onCancel = () => {
        let params = {
            id: selected.id,
            notes: reasonCancel,
        };
        console.log(params)
        setLoading(true);
        let url = `${process.env.REACT_APP_BASE_API_URL}gadai/exclusive`;
        AxiosCustomDelete(url, Config({ Authorization: `Bearer ${Cookies.get("access_token")}` }, params),
            (response) => {
                console.log(response.data.data)
                closeModalCancel()
                getData()
                setLoading(false);
            },
            (error) => {
                setLoading(false);
                if (error.response) {
                    SwalToast.fire({
                        icon: "error",
                        title: error.response.data.error.message,
                    });
                } else {
                    SwalToast.fire({
                        icon: "error",
                        title: "Whoops, something went wrong",
                    });
                }
            }
        );
    };

    const handleFilter = (e) => {
        const { value, name } = e.target;
        setFilterInput((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleEnterInput =
        (type = "enter") =>
            (event) => {
                const { name, value } = event.target;
                if (event.keyCode === 13 || type === "blur") {
                    setFilterInput((prev) => ({
                        ...prev,
                        [name]: name === "pageSize" && value === "" ? 10 : value,
                        page: 1,
                    }));
                }
            };

    const handleChangeEmployee = (e) => {
        console.log(e);
        setFilterInput((prev) => ({
            ...prev,
            assigned_employee_id: e?.value ? e.value : e,
        }));
    };

    const closeDetail = () => {
        setModalDetail(false)
        setSelected({})
        setCustomer({})
    };

    const showModalCancel = () => {
        setModalDetail(false)
        setModalCancel(true)
    };

    const closeModalCancel = () => {
        setReasonCancel('')
        setModalCancel(false)
        setSelected({})
        setCustomer({})
    };

    return (
        <>
            <div>
                <div className="px-3">
                    <div className="py-4 d-flex" style={{ fontSize: "13px", justifyContent: 'space-between' }}>
                        <div>
                            <Title text={"Daftar Gadai Eksklusif"} />
                            <Breadcrumb current={"Daftar Gadai Eksklusif"} />
                        </div>
                        <div>
                            <div style={{ padding: 10, border: "1px solid #DCDCDC", borderRadius: 5, alignItems: 'center', justifyContent: 'center' }}>
                                <div style={{ fontSize: 18, color: "#303030" }}>
                                    <TiUser style={{ fontSize: 24, color: "#D6D6D6" }} />
                                    <span style={{ fontWeight: 700 }}>{totalRecord}</span> Total Gadai Eksklusif
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex py-3 px-0">
                        <div className="d-flex col-6 px-0">
                            <TextInput
                                id="pageSize"
                                label="Tampilkan"
                                handleEnter={handleEnterInput}
                                handleChange={handleFilter}
                                width={68}
                                value={filterInput.pageSize}
                            />
                            <div className="col-6">
                                <TextInput
                                    label="Nama Nasabah"
                                    id="search"
                                    handleEnter={handleEnterInput}
                                    handleChange={handleFilter}
                                    value={filterInput.search}
                                    width={'100%'}
                                />
                            </div>
                            <div className="col-6">
                                Nama Officer :
                                <Select
                                    isClearable={true}
                                    className='mt-1'
                                    name="status"
                                    onChange={handleChangeEmployee}
                                    options={listEmployee}
                                    defaultValue={null}
                                />
                            </div>
                        </div>

                        <CanAccess
                            role={AuthorizationList.create_gadai_exclusive}
                            yes={
                                <div className="ml-auto align-self-end mb-3" onClick={() => history.push(AppRoutePath.EXCLUSIVE_ADD)}>
                                    <button className="btn border-438EBC bgc-2C465C text-white font-weight-semi-bold px-4">
                                        + Tambah Gadai
                                    </button>
                                </div>
                            }
                        />
                    </div>
                   
                    <div className="mt-4">
                        <CustomTable
                            columns={renderColumns(handleDetail)}
                            data={records}
                            loading={loading}
                            handleTableChange={handleTableChange}
                            pagination={tablePagination}
                        />
                    </div>
                </div>
                <Modal
                    className="modal-add"
                    centered
                    title='Detail'
                    visible={modalDetail}
                    onCancel={closeDetail}
                    footer={[
                        <Button
                            onClick={closeDetail}
                            style={{
                                border: "0.75px solid #DCDCDC",
                                borderRadius: 6,
                                width: 120,
                                height: 36,
                                color: "#000",
                                background: "#FFFFFF",
                            }}
                        >
                            Kembali
                        </Button>,
                        <CanAccess
                            role={AuthorizationList.cancel_gadai_exclusive}
                            yes={
                                <Button
                                    onClick={showModalCancel}
                                    style={{
                                        justifySelf: 'flex-start',
                                        border: "0.75px solid #DCDCDC",
                                        borderRadius: 6,
                                        width: 120,
                                        height: 36,
                                        color: "#fff",
                                        background: "#F23434",
                                    }}>
                                    Batalkan
                                </Button>
                            }
                        />
                    ]}
                >
                    <div className="d-flex mt-3">
                        <div style={{ flex: 1, color: "#A6A6A6" }}>No SBG :</div>
                        <div style={{ flex: 1.5, color: "#303030" }}>{selected.sbgCode || '-'}</div>
                    </div>
                    <div className="d-flex mt-3">
                        <div style={{ flex: 1, color: "#A6A6A6" }}>NIK:</div>
                        <div style={{ flex: 1.5, color: "#303030" }}>{selected.nik}</div>
                    </div>
                    <div className="d-flex mt-3">
                        <div style={{ flex: 1, color: "#A6A6A6" }}>Nama Nasabah :</div>
                        <div style={{ flex: 1.5, color: "#303030" }}>{selected.customerName}</div>
                    </div>
                    <div className="d-flex mt-3">
                        <div style={{ flex: 1, color: "#A6A6A6" }}>Jenis Kelamin :</div>
                        <div style={{ flex: 1.5, color: "#303030" }}>{customer.gender === 'L' ? 'Laki-laki' : 'Perempuan'}</div>
                    </div>
                    <div className="d-flex mt-3">
                        <div style={{ flex: 1, color: "#A6A6A6" }}>Tanggal Lahir :</div>
                        <div style={{ flex: 1.5, color: "#303030" }}>{moment(customer.birth_date).format('DD MMMM YYYY')}</div>
                    </div>
                    <div className="d-flex mt-3">
                        <div style={{ flex: 1, color: "#A6A6A6" }}>Alamat :</div>
                        <div style={{ flex: 1.5, color: "#303030" }}>{selected.address}</div>
                    </div>
                    <div className="d-flex mt-3">
                        <div style={{ flex: 1, color: "#A6A6A6" }}>No. Telepon Nasabah :</div>
                        <div style={{ flex: 1.5, color: "#303030" }}>{selected.phone}</div>
                    </div>
                    <div className="d-flex mt-3">
                        <div style={{ flex: 1, color: "#A6A6A6" }}>Email :</div>
                        <div style={{ flex: 1.5, color: "#303030" }}>{customer.email}</div>
                    </div>
                    <div className="d-flex mt-3">
                        <div style={{ flex: 1, color: "#A6A6A6" }}>Officer:</div>
                        <div style={{ flex: 1.5, color: "#303030" }}>{selected.officerName}</div>
                    </div>
                </Modal>
                <Modal
                    centered
                    title='Batalkan Proses Gadai'
                    visible={modalCancel}
                    onCancel={closeModalCancel}
                    footer={[
                        <Button
                            onClick={closeModalCancel}
                            style={{
                                border: "0.75px solid #DCDCDC",
                                borderRadius: 6,
                                width: 120,
                                height: 36,
                                color: "#000",
                                background: "#FFFFFF",
                            }}
                        >
                            Kembali
                        </Button>,
                        <Button
                            type="submit"
                            onClick={onCancel}
                            style={{
                                border: "0.75px solid #DCDCDC",
                                borderRadius: 6,
                                width: 120,
                                height: 36,
                                color: "#fff",
                                background: "#F23434",
                            }}
                        >
                            Batalkan
                        </Button>
                    ]}
                >
                    <div className="mt-3">
                        <div className="color-303030 my-2">Berikan Alasan :</div>
                        <Input.TextArea
                            required
                            rows="6"
                            type="text"
                            className="form-control border-DCDCDC text-input"
                            placeholder="Alasan"
                            value={reasonCancel}
                            onChange={(e) => setReasonCancel(e.target.value)}
                        />
                    </div>
                </Modal>
            </div>
        </>
    );
};

export default ExclusiveList;
